import LandingPage from "./pages/LandingPage/LandingPage";

export default function App() {
  return (
    <LandingPage />
  )
}